



























import { Prop, Component, Vue } from 'vue-property-decorator';
@Component
export default class TuckToggle extends Vue {
  @Prop([Boolean, Number]) readonly tuckState: boolean | number | undefined;
  @Prop(Boolean) readonly isDisabled: boolean | undefined;

  readonly TUCKED: string = 'Tucked';
  readonly UNTUCKED: string = 'Untucked';

  get disabledStyle(): Record<string, string> {
    return this.isDisabled ? { opacity: '0.2' } : {};
  }

  onClickToggle(): void {
    this.$emit('on-toggle-change');
  }
}
